'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _controlEditor = require('./controlEditor');

var _controlEditor2 = _interopRequireDefault(_controlEditor);

var _objectEditorEnhancer = require('./objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _chunk = require('lodash/chunk');

var _chunk2 = _interopRequireDefault(_chunk);

var _getSchemaKeys = require('../../utils/schema/getSchemaKeys');

var _getSchemaKeys2 = _interopRequireDefault(_getSchemaKeys);

var _DocEditor = require('./DocEditor');

var _DocEditor2 = _interopRequireDefault(_DocEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUi(_ref) {
  var uiSetting = _ref.uiSetting,
      schema = _ref.schema;

  if (uiSetting && uiSetting.editor) return uiSetting.editor;
  var keys = (0, _getSchemaKeys2.default)(schema, true).filter(function (opt) {
    return !['_id', '@@createdAt', '@@updatedAt'].includes(opt);
  });

  var rows = (0, _chunk2.default)(keys.map(function (k) {
    return { key: k };
  }), 2);

  return {
    groups: [{
      name: '',
      rows: rows
    }]
  };
}

var DocEditor = (0, _composeWithScope2.default)(
// schema, auth, db, page, uiSetting
(0, _consumeProps2.default)({
  auth: _propTypes.object,
  db: _propTypes.object,
  page: _propTypes.object,
  schema: _propTypes.object,
  uiSetting: _propTypes.object
}), (0, _injectProps2.default)({
  validator: _propTypes.func,
  computer: _propTypes.func
}), (0, _withState2.default)('value', 'onChange', null), _objectEditorEnhancer2.default, // => spliter

// x-auth, x-schema, x-db, x-page
_controlEditor2.default, // => actions

// x-uiSetting
(0, _withProps2.default)(function (_ref2) {
  var uiSetting = _ref2.uiSetting,
      schema = _ref2.schema,
      gotoDocList = _ref2.gotoDocList;
  return {
    ui: _extends({
      title: schema.name
    }, getUi({ uiSetting: uiSetting, schema: schema })),
    gotoDocList: gotoDocList
  };
}), // => ui

(0, _exposeProps2.default)(['value', 'onChange', 'schema', 'spliter', 'saveEditing', 'cancelEditing', 'routeToNewDoc', 'routeToCopyDoc', 'gotoDocList', 'ui']))(_DocEditor2.default);

DocEditor.displayName = 'DocEditor';

exports.default = DocEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/index.js
// module id = 1704
// module chunks = 0